import { createIcon, icons } from './icons';
import { UiComponent, UiComponentProps } from './ui-component';

export type InfoIconProps = UiComponentProps & {
	elementId: string;
	onClick: (event: MouseEvent) => void;
};

export class InfoIcon extends UiComponent<InfoIconProps> {
	render(): HTMLElement {
		const { onClick, elementId } = this.props;
		const learnMore = document.createElement('div');
		learnMore.id = elementId;
		const icon = createIcon(icons.INFO, ['icon', ...super.getClassNames()]);
		if (icon) {
			learnMore.appendChild(icon);
			icon.addEventListener('click', onClick);
		}
		learnMore.classList.add('learn-more');
		return learnMore;
	}
}
